import { makeStyles } from '@mui/styles'; 

const useStyles = makeStyles(theme => ({
  // --- General Container & Modal Styles ---
  modalContainer: { 
    backgroundColor: theme.palette.background.primary,
    margin: '30px auto', 
    borderRadius: 20,
    boxShadow: `0px 0px 38px ${theme.palette.common.blackShade || 'rgba(0,0,0,0.5)'}`, 
    paddingBottom: theme.spacing(2), 
    width: '70%', 
    maxWidth: 600, 
    height: 'auto', 
    minHeight: '400px', 
    display: 'flex',
    flexDirection: 'column',
  },
  modalContent: { 
    padding: theme.spacing(3), 
    flexGrow: 1, 
  },

  // --- Header Styles ---
  heading: { 
    backgroundColor: theme.palette.primary.main2, 
    width: '60%', 
    padding: theme.spacing(1, 2), 
    borderRadius: '0 20px 20px 0', 
    textAlign: 'left', 
    marginBottom: theme.spacing(2), 
  },
  textWhite: { 
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold, 
    fontSize: '1.25rem', 
  },

  // --- Form & Input Styles ---
  form: { 
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2), 
  },
  textField: {
    
  },
  inputTextStyle: { 
    color: theme.palette.text.primary, 
  },
  currentValueText: { 
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    display: 'block', 
  },

  // --- File Upload Section Styles ---
  fileUploadSection: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1), 
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    flexWrap: 'wrap',
  },
  selectedFileName: {
    color: theme.palette.text.primary,
    marginLeft: theme.spacing(1),
    flexShrink: 0, 
  },
  uploadedSuccessText: {
    color: theme.palette.success.main,
    marginTop: theme.spacing(1),
    fontSize: '0.875rem', 
  },

  // --- Switch Styles ---
  switchControl: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginTop: theme.spacing(1),
  },
  switchLabel: {
    color: theme.palette.text.primary,
    marginRight: theme.spacing(1),
  },
  switchLabelActive: { 
    color: theme.palette.success.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  switchLabelInactive: { 
    color: theme.palette.error.main,
    fontWeight: theme.typography.fontWeightMedium,
  },

  // --- Dialog Actions Styles ---
  dialogActions: { 
    padding: theme.spacing(2, 3), 
    justifyContent: 'flex-end',
    borderTop: `1px solid ${theme.palette.divider}`, 
  },
}));

export default useStyles;
